(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-links"] && !Shopify.designMode) return;
  try {
    
  class CollectionLinksShowcase extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-collection-link]').forEach((link) => {
        const activate = () => {
          const index = link.dataset.collectionLink;
          this.querySelectorAll('[data-collection-link]').forEach((item) => item.removeAttribute('aria-current'));
          this.querySelectorAll('[data-collection-image]').forEach((image) => { image.hidden = image.dataset.collectionImage !== index; });
          link.setAttribute('aria-current', 'true');
        };
        link.addEventListener('mouseenter', activate);
        link.addEventListener('focus', activate);
      });
    }
  }
  if (!customElements.get('collection-links-showcase')) customElements.define('collection-links-showcase', CollectionLinksShowcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('.filters-drawer').forEach((drawer) => {
    if (drawer.dataset.drawerReady === 'true') return;
    drawer.dataset.drawerReady = 'true';

    const trigger = drawer.querySelector(':scope > summary');
    const closeButton = drawer.querySelector('.filters-drawer__close');
    const backdrop = drawer.querySelector('.filters-drawer__backdrop');
    const panel = drawer.querySelector('.filters-drawer__panel');

    const closeDrawer = () => {
      drawer.open = false;
      trigger?.focus();
    };

    closeButton?.addEventListener('click', closeDrawer);
    backdrop?.addEventListener('click', closeDrawer);

    drawer.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('filters-drawer-open', drawer.open);
      if (drawer.open) closeButton?.focus();
    });

    document.addEventListener('keydown', (event) => {
      if (!drawer.open) return;
      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, select:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });

  document.querySelectorAll('[data-stock-order-grid]').forEach((grid) => {
    if (grid.dataset.stockOrderReady === 'true') return;
    grid.dataset.stockOrderReady = 'true';

    const nativePages = Number.parseInt(grid.dataset.stockOrderPages || '1', 10);
    const currentPage = Number.parseInt(grid.dataset.stockOrderCurrentPage || '1', 10);
    const productsPerPage = Number.parseInt(grid.dataset.productsPerPage || '30', 10);

    const stableStockPartition = (cards) => {
      const available = [];
      const unavailable = [];
      cards.forEach((card) => {
        if (card.dataset.productAvailable === 'true') available.push(card);
        else unavailable.push(card);
      });
      return available.concat(unavailable);
    };

    const nativeCards = Array.from(grid.querySelectorAll(':scope > .product-card'));
    if (nativeCards.length === 0) return;

    if (nativePages <= 1) {
      grid.replaceChildren(...stableStockPartition(nativeCards));
      return;
    }

    const showVendor = grid.dataset.showVendor === 'true';
    const showQuickAdd = grid.dataset.showQuickAdd === 'true';

    const normalizeCard = (card) => {
      if (!showVendor) card.querySelector('.product-card__body > .eyebrow')?.remove();
      if (!showQuickAdd) card.querySelector('.product-card__action')?.remove();
      return card;
    };

    const fetchSourcePage = async (page) => {
      const url = new URL(window.location.href);
      url.searchParams.set('view', 'stock-order');
      url.searchParams.set('page', String(page));

      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`Stock order request failed: ${response.status}`);

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = documentFragment.querySelector('[data-stock-order-source]');
      if (!source) throw new Error('Stock order source missing');

      return {
        totalPages: Number.parseInt(source.dataset.totalPages || '1', 10),
        cards: Array.from(source.querySelectorAll(':scope > .product-card')).map(normalizeCard)
      };
    };

    const applyGlobalStockOrder = async () => {
      try {
        grid.setAttribute('aria-busy', 'true');
        const firstSourcePage = await fetchSourcePage(1);
        const sourcePages = Math.max(1, firstSourcePage.totalPages);
        const allCards = firstSourcePage.cards.slice();

        for (let batchStart = 2; batchStart <= sourcePages; batchStart += 3) {
          const batchPages = [];
          for (let page = batchStart; page < batchStart + 3 && page <= sourcePages; page += 1) batchPages.push(page);
          const batchResults = await Promise.all(batchPages.map(fetchSourcePage));
          batchResults.forEach((result) => allCards.push(...result.cards));
        }

        const orderedCards = stableStockPartition(allCards);
        const start = Math.max(0, (currentPage - 1) * productsPerPage);
        const pageCards = orderedCards.slice(start, start + productsPerPage);
        if (pageCards.length > 0) grid.replaceChildren(...pageCards);
      } catch (error) {
        console.warn('[Deliquide] Classement des ruptures non appliqué, affichage Shopify conservé.', error);
      } finally {
        grid.removeAttribute('aria-busy');
      }
    };

    applyGlobalStockOrder();
  });

  document.querySelectorAll('[data-seo-accordion-groups]').forEach((container) => {
    const richText = container.querySelector('.metafield-rich_text_field');
    if (!richText) return;

    const sections = [];
    const preamble = [];
    let currentSection = null;

    Array.from(richText.childNodes).forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE && node.matches('h2')) {
        currentSection = [];
        sections.push(currentSection);
      }
      (currentSection || preamble).push(node);
    });

    if (sections.length === 0) sections.push(preamble.splice(0));
    else sections[0].unshift(...preamble);

    const labels = sections.map((nodes) => {
      const heading = nodes.find((node) => node.nodeType === Node.ELEMENT_NODE && node.matches('h2'));
      return heading?.textContent.trim() || container.dataset.seoFallbackLabel;
    });
    if (labels.some((label) => !label)) return;

    const accordionList = document.createElement('div');
    accordionList.className = 'collection-page__seo-accordions';

    sections.forEach((nodes, index) => {
      const accordion = document.createElement('details');
      accordion.className = 'collection-page__seo-item';

      const summary = document.createElement('summary');
      summary.textContent = labels[index];

      const panel = document.createElement('div');
      panel.className = 'rte collection-page__seo-panel';
      const panelContent = document.createElement('div');
      panelContent.className = 'metafield-rich_text_field';
      nodes.forEach((node) => panelContent.append(node));
      panel.append(panelContent);
      accordion.append(summary, panel);
      accordionList.append(accordion);
    });

    container.replaceChildren(accordionList);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.cart-drawer__panel');
        this.content = this.querySelector('[data-cart-drawer-content]');
        this.footer = this.querySelector('[data-cart-drawer-footer]');
        this.total = this.querySelector('[data-cart-drawer-total]');
        this.count = this.querySelector('[data-cart-drawer-count]');
        this.triggers = [...document.querySelectorAll('[data-cart-drawer-open]')];
        this.lastTrigger = null;
        this.closeTimer = null;

        this.triggers.forEach((trigger) => trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(trigger);
        }));
        this.querySelectorAll('[data-cart-drawer-close]').forEach((button) => button.addEventListener('click', () => this.close()));
        this.content.addEventListener('click', (event) => this.handleCartAction(event));
        document.addEventListener('cart:update', (event) => {
          const cart = event.detail?.resource;
          if (cart && !this.hidden) this.render(cart);
        });
        document.addEventListener('keydown', (event) => this.handleKeydown(event));
      }

      async open(trigger) {
        clearTimeout(this.closeTimer);
        this.lastTrigger = trigger;
        this.hidden = false;
        document.body.classList.add('cart-drawer-open');
        this.triggers.forEach((item) => item.setAttribute('aria-expanded', 'true'));
        this.content.innerHTML = '<p class="cart-drawer__loading">Chargement du panier…</p>';
        requestAnimationFrame(() => this.classList.add('is-open'));
        this.panel.focus();
        await this.refresh();
      }

      close() {
        this.classList.remove('is-open');
        document.body.classList.remove('cart-drawer-open');
        this.triggers.forEach((item) => item.setAttribute('aria-expanded', 'false'));
        this.closeTimer = window.setTimeout(() => {
          this.hidden = true;
          this.lastTrigger?.focus();
        }, 220);
      }

      async refresh() {
        try {
          const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Panier indisponible');
          this.render(await response.json());
        } catch (error) {
          this.content.innerHTML = '<p class="cart-drawer__empty">Impossible de charger le panier.</p>';
          this.footer.hidden = true;
        }
      }

      money(cents, currency = 'EUR') {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(Number(cents || 0) / 100);
      }

      escape(value) {
        return String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
      }

      render(cart) {
        const items = Array.isArray(cart.items) ? cart.items : [];
        const currency = cart.currency || 'EUR';
        this.count.textContent = `(${Number(cart.item_count || 0)})`;
        if (!items.length) {
          this.content.innerHTML = '<div class="cart-drawer__empty"><div><strong>Votre panier est vide</strong><p>Ajoutez vos produits préférés pour commencer.</p></div></div>';
          this.footer.hidden = true;
          return;
        }

        this.content.innerHTML = items.map((item) => {
          const image = item.image ? `<a class="cart-drawer__item-image" href="${this.escape(item.url)}"><img src="${this.escape(item.image)}" alt="" loading="lazy" width="176" height="176"></a>` : '<div class="cart-drawer__item-image"></div>';
          const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-variant">${this.escape(item.variant_title)}</p>` : '';
          return `<article class="cart-drawer__item" data-line-key="${this.escape(item.key)}">${image}<div class="cart-drawer__item-info"><a class="cart-drawer__item-title" href="${this.escape(item.url)}">${this.escape(item.product_title)}</a>${variant}<p class="cart-drawer__item-price">${this.money(item.final_line_price, currency)}</p><div class="cart-drawer__item-actions"><div class="cart-drawer__quantity" aria-label="Quantité"><button type="button" data-cart-quantity="${Math.max(0, Number(item.quantity) - 1)}" aria-label="Diminuer la quantité">−</button><span>${Number(item.quantity)}</span><button type="button" data-cart-quantity="${Number(item.quantity) + 1}" aria-label="Augmenter la quantité">+</button></div><button class="cart-drawer__remove" type="button" data-cart-quantity="0">Supprimer</button></div></div></article>`;
        }).join('');
        this.total.textContent = this.money(cart.total_price, currency);
        this.footer.hidden = false;
      }

      async handleCartAction(event) {
        const button = event.target.closest('[data-cart-quantity]');
        if (!button) return;
        const item = button.closest('[data-line-key]');
        if (!item) return;
        button.disabled = true;
        try {
          const response = await fetch(this.dataset.changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.dataset.lineKey, quantity: Number(button.dataset.cartQuantity) })
          });
          const cart = await response.json();
          if (!response.ok || cart.status) throw new Error(cart.description || 'Mise à jour impossible');
          this.render(cart);
          document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart, sourceId: 'cart-drawer' } }));
        } catch (error) {
          button.disabled = false;
        }
      }

      handleKeydown(event) {
        if (this.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [...this.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  if (!customElements.get('relay-header-progress')) {
    customElements.define('relay-header-progress', class RelayHeaderProgress extends HTMLElement {
      connectedCallback() {
        this.message = this.querySelector('[data-relay-header-message]');
        this.progress = this.querySelector('[data-relay-header-progress]');
        this.track = this.querySelector('[role="progressbar"]');
        document.addEventListener('cart:update', (event) => {
          const cart = event.detail?.resource;
          if (cart) this.render(cart);
          else this.refresh();
        });
        this.refresh();
      }

      async refresh() {
        try {
          const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          this.render(await response.json());
        } catch (error) {
          this.render({ item_count: Number(this.dataset.cartCount || 0), items_subtotal_price: Number(this.dataset.cartSubtotal || 0) });
        }
      }

      render(cart) {
        const itemCount = Number(cart.item_count || 0);
        const subtotal = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
        const remaining = Math.max(0, 2000 - subtotal);
        const progress = Math.min(100, subtotal / 20);
        this.classList.toggle('relay-header--hidden', itemCount === 0);
        if (this.progress) this.progress.style.width = `${progress}%`;
        if (this.track) this.track.setAttribute('aria-valuenow', String(Math.min(20, subtotal / 100)));
        if (this.message) this.message.textContent = remaining > 0 ? `Plus que ${new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(remaining / 100)}` : 'Livraison offerte';
        const count = document.querySelector('.cart-link span');
        if (count) count.textContent = itemCount;
      }
    });
  }

  const header = document.querySelector('[data-header-nav]');
  const desktopNav = document.querySelector('[data-desktop-nav]');

  if (desktopNav) {
    const desktopMenus = [...desktopNav.querySelectorAll('.desktop-nav__item')];

    desktopMenus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        desktopMenus.forEach((otherMenu) => {
          if (otherMenu !== menu) otherMenu.open = false;
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (desktopNav.contains(event.target)) return;
      desktopMenus.forEach((menu) => { menu.open = false; });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openMenu = desktopMenus.find((menu) => menu.open);
      if (!openMenu) return;
      openMenu.open = false;
      openMenu.querySelector('summary')?.focus();
    });
  }

  if (header) {
    const mobileMenu = header.querySelector('.mobile-nav');
    const closeButton = header.querySelector('.mobile-nav__close');
    const headerSection = header.closest('.shopify-section');

    if (header.dataset.stickyHeader === 'true' && headerSection) {
      const updateHeaderHeight = () => {
        document.documentElement.style.setProperty('--sticky-header-height', `${headerSection.offsetHeight}px`);
      };
      updateHeaderHeight();
      if ('ResizeObserver' in window) new ResizeObserver(updateHeaderHeight).observe(headerSection);
      window.addEventListener('resize', updateHeaderHeight, { passive: true });
    }

    closeButton?.addEventListener('click', () => {
      mobileMenu.open = false;
      mobileMenu.querySelector(':scope > summary')?.focus();
    });

    mobileMenu?.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('mobile-menu-open', mobileMenu.open);
      if (mobileMenu.open) closeButton?.focus();
    });

    document.addEventListener('keydown', (event) => {
      if (!mobileMenu?.open) return;
      if (event.key === 'Escape') {
        mobileMenu.open = false;
        mobileMenu.querySelector(':scope > summary')?.focus();
        return;
      }
      if (event.key !== 'Tab') return;
      const panel = mobileMenu.querySelector('.mobile-nav__panel');
      const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nicotine-calculator"] && !Shopify.designMode) return;
  try {
    
  class NicotineCalculator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.products = [];
      this.filteredProducts = [];
      this.selectedProduct = null;
      this.selectedVariant = null;
      this.activeResult = -1;
      this.mode = 'product';
      this.config = {
        productsUrl: this.dataset.productsUrl,
        cartAddUrl: this.dataset.cartAddUrl,
        cartUrl: this.dataset.cartUrl,
        boosterVariantId: Number(this.dataset.boosterVariantId),
        boosterPrice: Number(this.dataset.boosterPrice),
        boosterAvailable: this.dataset.boosterAvailable === 'true',
        boosterStrength: Number(this.dataset.boosterStrength),
        boosterVolume: Number(this.dataset.boosterVolume),
        currency: this.dataset.currency,
      };
      this.i18n = JSON.parse(this.querySelector('[data-calculator-translations]').textContent);
      this.searchInput = this.querySelector('[data-product-search]');
      this.results = this.querySelector('[data-product-results]');
      this.productsStatus = this.querySelector('[data-products-status]');
      this.variantSelect = this.querySelector('[data-variant-select]');
      this.targetInput = this.querySelector('[data-target-rate]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      this.mobileResult = this.querySelector('[data-mobile-result]');
      this.resultPanel = this.querySelector('.nicotine-calculator__result-panel');
      this.bindEvents();
      this.observeResult();
      this.loadProducts();
      this.calculate();
    }

    bindEvents() {
      this.querySelectorAll('input[type="radio"][name^="calculator-mode-"]').forEach((input) => {
        input.addEventListener('change', () => this.setMode(input.value));
      });
      this.searchInput.addEventListener('input', () => this.searchProducts());
      this.searchInput.addEventListener('focus', () => this.searchProducts());
      this.searchInput.addEventListener('keydown', (event) => this.handleSearchKeys(event));
      this.querySelector('[data-clear-product]').addEventListener('click', () => this.clearProduct());
      this.variantSelect.addEventListener('change', () => this.syncVariant());
      this.querySelectorAll('[data-product-volume], [data-product-current], [data-custom-volume], [data-custom-current], [data-target-rate]').forEach((input) => {
        input.addEventListener('input', () => this.calculate());
      });
      this.querySelectorAll('[data-rate]').forEach((button) => {
        button.addEventListener('click', () => {
          this.targetInput.value = button.dataset.rate;
          this.querySelectorAll('[data-rate]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          this.calculate();
        });
      });
      this.addButton.addEventListener('click', () => this.addToCart());
      this.querySelector('[data-view-result]').addEventListener('click', () => {
        this.resultPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeResults();
      });
    }

    observeResult() {
      this.resultObserver = new IntersectionObserver((entries) => {
        this.mobileResult.classList.toggle('is-result-visible', entries[0].isIntersecting);
      }, { threshold: 0.18 });
      this.resultObserver.observe(this.resultPanel);
    }

    async loadProducts() {
      try {
        const response = await fetch(this.config.productsUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Products unavailable');
        const data = await response.json();
        this.products = data.products.filter((product) => product.variants.some((variant) => variant.available));
        this.productsStatus.textContent = this.i18n.productsReady.replace('[count]', this.products.length);
      } catch (error) {
        this.productsStatus.textContent = this.i18n.productsError;
        this.searchInput.disabled = true;
      }
    }

    normalize(value) {
      return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    searchProducts() {
      const query = this.normalize(this.searchInput.value).trim();
      if (!this.products.length) return;
      this.filteredProducts = this.products.filter((product) => {
        const haystack = this.normalize([product.title, product.vendor, product.product_type].join(' '));
        return !query || haystack.includes(query);
      }).slice(0, 9);
      this.activeResult = -1;
      this.renderResults();
    }

    renderResults() {
      this.results.replaceChildren();
      if (!this.filteredProducts.length) {
        const item = document.createElement('li');
        item.className = 'nicotine-calculator__field-note';
        item.textContent = this.i18n.noProducts;
        this.results.append(item);
      } else {
        this.filteredProducts.forEach((product, index) => {
          const item = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.role = 'option';
          button.dataset.resultIndex = index;
          button.setAttribute('aria-selected', String(index === this.activeResult));
          const image = document.createElement('img');
          image.loading = 'lazy';
          image.alt = '';
          image.src = product.images?.[0]?.src || '';
          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = product.title;
          const vendor = document.createElement('small');
          vendor.textContent = product.vendor || product.product_type || '';
          const price = document.createElement('strong');
          price.textContent = this.formatMoney(this.lowestPrice(product));
          copy.append(title, vendor);
          button.append(image, copy, price);
          button.addEventListener('click', () => this.selectProduct(product));
          item.append(button);
          this.results.append(item);
        });
      }
      this.results.hidden = false;
      this.searchInput.setAttribute('aria-expanded', 'true');
    }

    handleSearchKeys(event) {
      if (this.results.hidden && event.key === 'ArrowDown') {
        this.searchProducts();
        event.preventDefault();
        return;
      }
      if (!['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(event.key)) return;
      if (event.key === 'Escape') {
        this.closeResults();
        return;
      }
      if (event.key === 'Enter' && this.activeResult >= 0) {
        event.preventDefault();
        this.selectProduct(this.filteredProducts[this.activeResult]);
        return;
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        this.activeResult = (this.activeResult + direction + this.filteredProducts.length) % this.filteredProducts.length;
        this.results.querySelectorAll('[role="option"]').forEach((button, index) => {
          button.setAttribute('aria-selected', String(index === this.activeResult));
          if (index === this.activeResult) button.scrollIntoView({ block: 'nearest' });
        });
      }
    }

    closeResults() {
      this.results.hidden = true;
      this.searchInput.setAttribute('aria-expanded', 'false');
    }

    selectProduct(product) {
      this.selectedProduct = product;
      this.searchInput.value = product.title;
      this.closeResults();
      const availableVariants = product.variants.filter((variant) => variant.available);
      this.variantSelect.replaceChildren();
      availableVariants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = `${variant.title} — ${this.formatMoney(this.priceToCents(variant.price))}`;
        this.variantSelect.append(option);
      });
      const preferredVariant = [...availableVariants].sort((a, b) => this.extractNicotine(a.title) - this.extractNicotine(b.title))[0];
      this.variantSelect.value = preferredVariant.id;
      this.querySelector('[data-variant-field]').hidden = availableVariants.length < 2;
      this.querySelector('[data-product-details]').hidden = false;
      this.querySelector('[data-selected-product]').hidden = false;
      this.querySelector('[data-selected-title]').textContent = product.title;
      const image = this.querySelector('[data-selected-image]');
      image.src = product.images?.[0]?.src || '';
      image.alt = product.title;
      this.syncVariant();
    }

    syncVariant() {
      this.selectedVariant = this.selectedProduct.variants.find((variant) => String(variant.id) === this.variantSelect.value);
      const volume = this.extractVolume([
        this.selectedProduct.title,
        this.selectedVariant.title,
        this.selectedProduct.body_html,
        this.selectedProduct.images?.[0]?.src,
      ].join(' '));
      const nicotineSource = this.selectedVariant.title === 'Default Title'
        ? `${this.selectedProduct.title} ${this.selectedProduct.body_html}`
        : this.selectedVariant.title;
      const currentRate = this.extractNicotine(nicotineSource);
      this.querySelector('[data-product-volume]').value = volume || '';
      this.querySelector('[data-product-current]').value = currentRate;
      const meta = [
        this.selectedVariant.title !== 'Default Title' ? this.selectedVariant.title : '',
        this.formatMoney(this.priceToCents(this.selectedVariant.price)),
        volume ? this.i18n.volumeDetected.replace('[volume]', this.formatNumber(volume)) : '',
        this.i18n.currentDetected.replace('[rate]', this.formatNumber(currentRate)),
      ].filter(Boolean).join(' · ');
      this.querySelector('[data-selected-meta]').textContent = meta;
      this.calculate();
    }

    clearProduct() {
      this.selectedProduct = null;
      this.selectedVariant = null;
      this.searchInput.value = '';
      this.querySelector('[data-selected-product]').hidden = true;
      this.querySelector('[data-product-details]').hidden = true;
      this.querySelector('[data-variant-field]').hidden = true;
      this.calculate();
      this.searchInput.focus();
    }

    setMode(mode) {
      this.mode = mode;
      this.querySelectorAll('[data-mode-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.modePanel !== mode;
      });
      this.closeResults();
      this.calculate();
    }

    extractVolume(value) {
      const matches = [...String(value || '').matchAll(/(\d+(?:[.,]\d+)?)\s*ml\b/gi)];
      const values = matches.map((match) => Number(match[1].replace(',', '.'))).filter((number) => number > 0 && number <= 1000);
      return values.length ? values[values.length - 1] : 0;
    }

    extractNicotine(value) {
      const match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*mg(?:\s*\/\s*ml)?/i);
      return match ? Number(match[1].replace(',', '.')) : 0;
    }

    calculate() {
      const empty = this.querySelector('[data-empty-result]');
      const result = this.querySelector('[data-calculation]');
      const error = this.querySelector('[data-calculation-error]');
      error.hidden = true;
      let volume;
      let currentRate;
      if (this.mode === 'product') {
        if (!this.selectedVariant) return this.showEmpty(this.i18n.selectProduct);
        volume = Number(this.querySelector('[data-product-volume]').value);
        currentRate = Number(this.querySelector('[data-product-current]').value);
      } else {
        volume = Number(this.querySelector('[data-custom-volume]').value);
        currentRate = Number(this.querySelector('[data-custom-current]').value);
      }
      const targetRate = Number(this.targetInput.value);
      if (!Number.isFinite(volume) || volume <= 0) return this.showError(this.i18n.invalidVolume);
      if (!Number.isFinite(currentRate) || !Number.isFinite(targetRate) || currentRate < 0 || targetRate < 0) return this.showError(this.i18n.invalidRate);
      if (targetRate < currentRate) return this.showError(this.i18n.rateTooLow.replace('[current]', this.formatNumber(currentRate)));
      if (targetRate >= this.config.boosterStrength && targetRate > currentRate) return this.showError(this.i18n.rateTooHigh);

      const exactVolume = targetRate === currentRate
        ? 0
        : volume * (targetRate - currentRate) / (this.config.boosterStrength - targetRate);
      const boosterEquivalent = exactVolume / this.config.boosterVolume;
      const bottleCount = exactVolume > 0 ? Math.ceil(boosterEquivalent - 0.000001) : 0;
      const fullBottles = Math.floor(boosterEquivalent + 0.000001);
      const partialVolume = Math.max(0, exactVolume - fullBottles * this.config.boosterVolume);
      const remaining = Math.max(0, bottleCount * this.config.boosterVolume - exactVolume);
      const finalVolume = volume + exactVolume;
      const allBottlesRate = bottleCount > 0
        ? (currentRate * volume + this.config.boosterStrength * bottleCount * this.config.boosterVolume) / (volume + bottleCount * this.config.boosterVolume)
        : currentRate;

      empty.hidden = true;
      result.hidden = false;
      this.querySelector('[data-exact-volume]').textContent = this.formatNumber(exactVolume, 2);
      this.querySelector('[data-bottle-count]').textContent = bottleCount;
      this.querySelector('[data-bottle-label]').textContent = bottleCount === 1 ? this.i18n.boosterSingular : this.i18n.boosterPlural;
      this.querySelector('[data-final-volume]').textContent = this.formatNumber(finalVolume, 2);
      this.querySelector('[data-booster-equivalent]').textContent = this.formatNumber(boosterEquivalent, 2);
      this.querySelector('[data-booster-remaining]').textContent = this.formatNumber(remaining, 2);
      this.mobileResult.hidden = false;
      this.querySelector('[data-mobile-exact-volume]').textContent = this.formatNumber(exactVolume, 2);
      this.querySelector('[data-mobile-bottle-count]').textContent = bottleCount;
      this.querySelector('[data-mobile-bottle-label]').textContent = bottleCount === 1 ? this.i18n.boosterSingular : this.i18n.boosterPlural;

      let breakdown = this.i18n.noBooster;
      if (bottleCount > 0 && partialVolume < 0.005) {
        const bottleText = fullBottles === 1 ? this.i18n.fullBottle : this.i18n.fullBottles;
        breakdown = bottleText.replace('[count]', fullBottles);
      } else if (bottleCount > 0) {
        const fullText = fullBottles > 0
          ? (fullBottles === 1 ? this.i18n.fullBottle : this.i18n.fullBottles).replace('[count]', fullBottles)
          : '';
        const partialText = this.i18n.partialBottle.replace('[volume]', this.formatNumber(partialVolume, 2));
        breakdown = [fullText, partialText].filter(Boolean).join(' + ');
      }
      this.querySelector('[data-breakdown]').textContent = breakdown;
      const allBottlesNote = this.querySelector('[data-all-bottles-note]');
      allBottlesNote.hidden = remaining < 0.005;
      allBottlesNote.textContent = this.i18n.allBottlesNote.replace('[count]', bottleCount).replace('[rate]', this.formatNumber(allBottlesRate, 2));
      this.updateCartSummary(bottleCount);
    }

    showEmpty(message) {
      const empty = this.querySelector('[data-empty-result]');
      this.querySelector('[data-calculation]').hidden = true;
      this.querySelector('[data-calculation-error]').hidden = true;
      empty.hidden = false;
      empty.querySelector('p').textContent = message;
      this.mobileResult.hidden = true;
      this.addButton.disabled = true;
    }

    showError(message) {
      this.querySelector('[data-empty-result]').hidden = true;
      this.querySelector('[data-calculation]').hidden = true;
      const error = this.querySelector('[data-calculation-error]');
      error.textContent = message;
      error.hidden = false;
      this.mobileResult.hidden = true;
      this.addButton.disabled = true;
    }

    updateCartSummary(bottleCount) {
      const summary = this.querySelector('[data-cart-summary]');
      summary.replaceChildren();
      let total = 0;
      if (this.mode === 'product' && this.selectedVariant) {
        const row = document.createElement('span');
        const label = document.createElement('span');
        label.textContent = this.i18n.liquidLine.replace('[title]', this.selectedProduct.title);
        const price = document.createElement('strong');
        const cents = this.priceToCents(this.selectedVariant.price);
        price.textContent = this.formatMoney(cents);
        total += cents;
        row.append(label, price);
        summary.append(row);
      }
      if (bottleCount > 0) {
        const row = document.createElement('span');
        const label = document.createElement('span');
        label.textContent = this.i18n.boosterLine.replace('[count]', bottleCount);
        const price = document.createElement('strong');
        const cents = this.config.boosterPrice * bottleCount;
        price.textContent = this.formatMoney(cents);
        total += cents;
        row.append(label, price);
        summary.append(row);
      }
      const label = this.querySelector('[data-cta-label]');
      if (this.mode === 'product' && bottleCount > 0) label.textContent = this.i18n.addAll;
      else if (this.mode === 'product') label.textContent = this.i18n.addLiquid;
      else if (bottleCount > 0) label.textContent = this.i18n.addBoosters;
      else label.textContent = this.i18n.nothingToAdd;
      this.querySelector('[data-cta-price]').textContent = total > 0 ? this.formatMoney(total) : '';
      const hasLiquid = this.mode === 'product' && this.selectedVariant?.available;
      const hasBoosters = bottleCount > 0 && this.config.boosterAvailable;
      this.currentBottleCount = bottleCount;
      this.addButton.disabled = !(hasLiquid || hasBoosters) || (bottleCount > 0 && !this.config.boosterAvailable);
    }

    async addToCart() {
      const items = [];
      if (this.mode === 'product' && this.selectedVariant?.available) items.push({ id: Number(this.selectedVariant.id), quantity: 1 });
      if (this.currentBottleCount > 0) items.push({ id: this.config.boosterVariantId, quantity: this.currentBottleCount });
      if (!items.length) return;
      const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((item) => item.dataset.sectionId);
      const status = this.querySelector('[data-cart-status]');
      const ctaLabel = this.querySelector('[data-cta-label]');
      const previousLabel = ctaLabel.textContent;
      this.addButton.disabled = true;
      ctaLabel.textContent = this.i18n.adding;
      status.textContent = '';
      try {
        const response = await fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: sectionIds.join(','), sections_url: window.location.pathname }),
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.i18n.cartError);
        const cartResponse = await fetch(this.config.cartUrl, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: this.id || 'nicotine-calculator',
            data: { source: 'nicotine-calculator', itemCount: cart.item_count, sections: data.sections },
          },
        }));
        ctaLabel.textContent = this.i18n.added;
        status.textContent = this.i18n.added;
        setTimeout(() => {
          ctaLabel.textContent = previousLabel;
          this.addButton.disabled = false;
        }, 1800);
      } catch (error) {
        ctaLabel.textContent = previousLabel;
        status.textContent = error.message || this.i18n.cartError;
        this.addButton.disabled = false;
      }
    }

    lowestPrice(product) {
      return Math.min(...product.variants.filter((variant) => variant.available).map((variant) => this.priceToCents(variant.price)));
    }

    priceToCents(value) {
      return Math.round(Number(value) * 100);
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: this.config.currency || 'EUR',
      }).format(cents / 100);
    }

    formatNumber(value, digits = 1) {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        maximumFractionDigits: digits,
      }).format(Number(value));
    }
  }

  if (!customElements.get('nicotine-calculator')) {
    customElements.define('nicotine-calculator', NicotineCalculator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder"] && !Shopify.designMode) return;
  try {
    
  class ProductFinder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-finder-config]').textContent);
      this.labels = this.config.labels;
      this.state = {};
      this.history = [];
      this.products = [];
      this.flavorMap = new Map();
      this.flavorMode = 'flavor';
      this.step = this.querySelector('[data-finder-step]');
      this.results = this.querySelector('[data-finder-results]');
      this.status = this.querySelector('[data-finder-status]');
      this.choices = this.querySelector('[data-step-choices]');
      this.actions = this.querySelector('[data-step-actions]');
      this.backButton = this.querySelector('[data-finder-back]');
      this.resetButton = this.querySelector('[data-finder-reset]');
      this.summary = this.querySelector('[data-finder-summary]');
      this.liveCount = this.querySelector('[data-live-count]');
      this.progressFill = this.querySelector('[data-progress-fill]');
      this.progressText = this.querySelector('[data-progress-text]');
      this.rangePanel = this.querySelector('[data-step-range]');
      this.flavorModeControl = this.querySelector('[data-flavor-mode]');
      this.choiceSearchWrap = this.querySelector('[data-choice-search-wrap]');
      this.choiceSearch = this.querySelector('[data-choice-search]');
      this.rangeMin = this.querySelector('[data-range-min]');
      this.rangeMax = this.querySelector('[data-range-max]');
      this.backButton.addEventListener('click', () => this.goBack());
      this.resetButton.addEventListener('click', () => this.reset());
      this.querySelector('[data-empty-back]').addEventListener('click', () => this.goBack());
      this.rangeMin.addEventListener('input', () => this.syncRange('min'));
      this.rangeMax.addEventListener('input', () => this.syncRange('max'));
      this.querySelector('[data-step-all]').addEventListener('click', () => this.skipStep());
      this.querySelector('[data-step-continue]').addEventListener('click', () => this.commitStep());
      this.flavorModeControl.querySelectorAll('[data-flavor-mode-value]').forEach((button) => {
        button.addEventListener('click', () => this.setFlavorMode(button.dataset.flavorModeValue));
      });
      this.choiceSearch.addEventListener('input', () => this.filterChoices());
      this.loadProducts();
    }

    async loadProducts() {
      try {
        if (!this.dataset.productsUrl) throw new Error(this.labels.catalogError);
        this.flavorMap = await this.loadFlavorMap();
        const products = [];
        const seen = new Set();
        for (let page = 1; page <= 20; page += 1) {
          const url = new URL(this.dataset.productsUrl, window.location.origin);
          url.searchParams.set('limit', '250');
          url.searchParams.set('page', String(page));
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(this.labels.catalogError);
          const data = await response.json();
          const batch = data.products || [];
          batch.forEach((product) => {
            if (seen.has(product.id)) return;
            seen.add(product.id);
            products.push(product);
          });
          if (batch.length < 250) break;
        }
        this.products = products.map((product) => this.hydrateProduct(product));
        if (!this.products.length) throw new Error(this.labels.emptyCatalog);
        this.status.hidden = true;
        this.render();
      } catch (error) {
        this.status.innerHTML = '';
        this.status.textContent = error.message || this.labels.catalogError;
      }
    }

    parseFlavorPage(root) {
      const script = root.querySelector('[data-flavor-page]');
      if (!script) return { currentPage: 1, totalPages: 1, products: [] };
      return {
        currentPage: Number(script.dataset.currentPage || 1),
        totalPages: Number(script.dataset.totalPages || 1),
        products: JSON.parse(script.textContent),
      };
    }

    async loadFlavorMap() {
      const initial = this.parseFlavorPage(this);
      const pages = [initial];
      const requests = [];
      for (let page = 1; page <= initial.totalPages; page += 1) {
        if (page === initial.currentPage) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('page', String(page));
        requests.push(
          fetch(url, { headers: { Accept: 'text/html' } }).then(async (response) => {
            if (!response.ok) throw new Error(this.labels.catalogError);
            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            return this.parseFlavorPage(documentFragment);
          }),
        );
      }
      pages.push(...await Promise.all(requests));
      const map = new Map();
      pages.flatMap((page) => page.products).forEach((product) => {
        map.set(product.handle, {
          flavor: this.unique(product.flavors || []),
          taste: this.unique(product.tastes || []),
          prixDeliquide: Boolean(product.prixDeliquide),
        });
      });
      return map;
    }

    normalize(value) {
      return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    slug(value) {
      return this.normalize(value).replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    labelize(value) {
      const clean = String(value || '').replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
      return clean ? clean.charAt(0).toUpperCase() + clean.slice(1) : '';
    }

    item(value, label) {
      return { value: this.slug(value), label: label || this.labelize(value) };
    }

    unique(items) {
      const map = new Map();
      items.filter((item) => item && item.value).forEach((item) => {
        if (!map.has(item.value)) map.set(item.value, item);
      });
      return [...map.values()].sort((a, b) => a.label.localeCompare(b.label, document.documentElement.lang, { numeric: true }));
    }

    tags(product) {
      if (Array.isArray(product.tags)) return product.tags;
      return String(product.tags || '').split(',').map((tag) => tag.trim()).filter(Boolean);
    }

    tagValues(product, prefixes) {
      const values = [];
      this.tags(product).forEach((tag) => {
        const normalizedTag = this.normalize(tag);
        prefixes.forEach((prefix) => {
          if (!normalizedTag.startsWith(this.normalize(prefix))) return;
          const depth = prefix.split(':').length - 1;
          const value = tag.split(':').slice(depth).join(':').trim();
          if (value) values.push(this.item(value));
        });
      });
      return this.unique(values);
    }

    optionValues(product, names) {
      const values = [];
      (product.options || []).forEach((option) => {
        const name = this.normalize(option.name);
        if (!names.some((candidate) => name.includes(candidate))) return;
        (option.values || []).forEach((value) => {
          if (value && this.normalize(value) !== 'default title') values.push(this.item(value));
        });
      });
      return this.unique(values);
    }

    productText(product) {
      return this.normalize([product.title, product.vendor, product.product_type, ...this.tags(product)].join(' '));
    }

    inferCategory(product) {
      const tagged = this.tagValues(product, ['guide:categorie:', 'guide:category:']);
      if (tagged.length) return tagged;
      const text = this.productText(product);
      const productType = this.normalize(product.product_type);
      if (productType === 'cartouche' || productType === 'pods') return [this.item('puffs', this.labels.categoryPuffs)];
      if (/(puff|chicha)/.test(text)) return [this.item('puffs', this.labels.categoryPuffs)];
      if (/(base|arome|arôme|concentre|concentré|booster|nicotine)/.test(text) && !/(e-liquide|eliquide)/.test(this.normalize(product.product_type))) return [this.item('diy', this.labels.categoryDiy)];
      if (/(resistance|résistance|coil|kit|box|mod|atomiseur|clearomiseur|reservoir|réservoir|accu|batterie|accessoire|cartouche|pod)/.test(text)) return [this.item('materiel', this.labels.categoryHardware)];
      if (/(e-liquide|eliquide|liquide)/.test(text)) return [this.item('e-liquides', this.labels.categoryEliquids)];
      return [this.item('materiel', this.labels.categoryHardware)];
    }

    inferSubcategory(product, category) {
      const tagged = this.tagValues(product, ['guide:sous-categorie:', 'guide:sous-catégorie:', 'guide:type:']);
      if (tagged.length) return tagged;
      const text = this.productText(product);
      if (category === 'puffs') {
        const productType = this.normalize(product.product_type);
        if (/(pre-rempli|pré-rempli|prerempli|prérempli|prefilled|cartouche)/.test(text)) return [this.item('pods-preremplis', this.labels.subcategoryPrefilled)];
        if (/(remplissable|rechargeable|refillable)/.test(text)) return [this.item('pods-remplissables', this.labels.subcategoryRefillable)];
        if (productType === 'cartouche' || productType === 'pods') return [this.item('pods-preremplis', this.labels.subcategoryPrefilled)];
        return [this.item('a-liquide', this.labels.subcategoryLiquid)];
      }
      if (category === 'diy') {
        if (/(arome|arôme|concentre|concentré)/.test(text)) return [this.item('aromes', this.labels.subcategoryFlavors)];
        if (/(nicotine|booster)/.test(text)) return [this.item('nicotines', this.labels.subcategoryNicotine)];
        return [this.item('bases', this.labels.subcategoryBases)];
      }
      if (category === 'materiel') {
        if (/(resistance|résistance|coil)/.test(text)) return [this.item('resistances', this.labels.subcategoryCoils)];
        if (/(kit)/.test(text)) return [this.item('kits-complets', this.labels.subcategoryKits)];
        if (/(box|mod)/.test(text)) return [this.item('boxs', this.labels.subcategoryBoxes)];
        if (/(atomiseur|clearomiseur|reservoir|réservoir|tank)/.test(text)) return [this.item('atomiseurs', this.labels.subcategoryAtomizers)];
        if (/(accu|batterie)/.test(text)) return [this.item('accus', this.labels.subcategoryBatteries)];
        return [this.item('accessoires', this.labels.subcategoryAccessories)];
      }
      return [];
    }

    extractFormats(product) {
      const values = [
        ...this.tagValues(product, ['guide:format:', 'format:', 'contenance:']),
        ...this.optionValues(product, ['format', 'contenance', 'volume']),
      ];
      const text = [product.title, ...(product.variants || []).map((variant) => variant.title)].join(' ');
      [...text.matchAll(/(\d+(?:[.,]\d+)?)\s*ml\b/gi)].forEach((match) => {
        const number = Number(match[1].replace(',', '.'));
        if (number > 0 && number <= 2000) values.push(this.item(`${number}-ml`, `${number} ml`));
      });
      return this.unique(values);
    }

    extractNicotine(product) {
      const numbers = [];
      const tagged = this.tagValues(product, ['guide:nicotine:', 'nicotine:', 'taux:']);
      tagged.forEach((entry) => {
        const match = entry.label.match(/\d+(?:[.,]\d+)?/);
        if (match) numbers.push(Number(match[0].replace(',', '.')));
      });
      const options = this.optionValues(product, ['nicotine', 'taux', 'dosage']);
      options.forEach((entry) => {
        if (/sans|zero|zéro/.test(this.normalize(entry.label))) numbers.push(0);
        const match = entry.label.match(/\d+(?:[.,]\d+)?/);
        if (match) numbers.push(Number(match[0].replace(',', '.')));
      });
      const text = [product.title, ...(product.variants || []).map((variant) => variant.title)].join(' ');
      [...text.matchAll(/(\d+(?:[.,]\d+)?)\s*mg(?:\s*\/\s*ml)?/gi)].forEach((match) => numbers.push(Number(match[1].replace(',', '.'))));
      return [...new Set(numbers.filter((number) => number >= 0 && number <= 20))].sort((a, b) => a - b);
    }

    extractPuffs(product, category) {
      const values = this.tagValues(product, ['guide:taffs:', 'guide:puffs:', 'taffs:', 'puffs:', 'bouffees:', 'bouffées:']);
      const text = [product.title, ...(product.variants || []).map((variant) => variant.title)].join(' ');
      [...text.matchAll(/(\d[\d\s.]*)\s*(?:taffs?|puffs?|bouff[eé]es?)/gi)].forEach((match) => {
        const number = Number(match[1].replace(/[\s.]/g, ''));
        if (number > 0) values.push(this.item(`${number}`, new Intl.NumberFormat(document.documentElement.lang).format(number)));
      });
      if (category === 'puffs') {
        [...text.matchAll(/(\d+(?:[.,]\d+)?)\s*k\b/gi)].forEach((match) => {
          const number = Number(match[1].replace(',', '.')) * 1000;
          if (number > 0) values.push(this.item(`${number}`, new Intl.NumberFormat(document.documentElement.lang).format(number)));
        });
      }
      return this.unique(values);
    }

    hydrateProduct(product) {
      const category = this.inferCategory(product);
      const primaryCategory = category[0]?.value;
      const subcategory = this.inferSubcategory(product, primaryCategory);
      const metafields = this.flavorMap.get(product.handle) || {};
      const flavor = metafields.flavor || [];
      const taste = metafields.taste || [];
      let model = this.unique([
        ...this.tagValues(product, ['guide:modele:', 'guide:modèle:', 'modele:', 'modèle:']),
        ...this.optionValues(product, ['modele', 'modèle', 'model']),
      ]);
      if (!model.length && subcategory.some((item) => item.value === 'resistances')) model = [this.item(product.handle, product.title)];
      product.dimensions = {
        entry: [
          this.item('type', this.labels.pathType),
          this.item('brand', this.labels.pathBrand),
        ],
        category,
        subcategory,
        flavor,
        taste,
        format: this.extractFormats(product),
        nicotine: this.extractNicotine(product),
        puffs: this.extractPuffs(product, primaryCategory),
        brand: this.unique([
          ...this.tagValues(product, ['guide:marque:', 'marque:', 'brand:']),
          ...(product.vendor ? [this.item(product.vendor, product.vendor)] : []),
        ]),
        model,
      };
      return product;
    }

    getFlow() {
      const entry = this.state.entry?.[0];
      const category = this.state.category?.[0];
      const subcategory = this.state.subcategory?.[0];
      const entryStep = { key: 'entry' };
      const flavorStep = { key: this.flavorMode, multi: true, flavorFilter: true };
      if (!entry) return [entryStep];
      if (entry === 'brand') return [entryStep, { key: 'brand' }];
      if (!category) return [entryStep, { key: 'category' }];
      if (category === 'e-liquides') return [
        entryStep,
        flavorStep,
        { key: 'format' },
        { key: 'nicotine', range: true },
      ];
      if (category === 'puffs') return [
        entryStep,
        { key: 'subcategory' },
        ...(subcategory ? [flavorStep, { key: 'puffs' }] : []),
      ];
      if (category === 'diy') {
        const flow = [entryStep, { key: 'subcategory' }];
        if (subcategory === 'bases') flow.push({ key: 'format' });
        if (subcategory === 'aromes') flow.push(flavorStep, { key: 'format' });
        return flow;
      }
      if (category === 'materiel') {
        const flow = [entryStep, { key: 'subcategory' }];
        if (subcategory === 'resistances') flow.push({ key: 'brand', optional: true }, { key: 'model' });
        if (['kits-complets', 'boxs', 'atomiseurs'].includes(subcategory)) flow.push({ key: 'brand', optional: true });
        return flow;
      }
      return [
        entryStep,
        { key: 'subcategory', optional: true },
        { ...flavorStep, optional: true },
        { key: 'format', optional: true },
        { key: 'nicotine', range: true, optional: true },
        { key: 'puffs', optional: true },
        { key: 'brand', optional: true },
        { key: 'model', optional: true },
      ];
    }

    matches(product, excludedKey, provisional) {
      const state = { ...this.state };
      if (excludedKey) delete state[excludedKey];
      Object.assign(state, provisional || {});
      return Object.entries(state).every(([key, selected]) => {
        if (!selected || (Array.isArray(selected) && selected.length === 0)) return true;
        const values = product.dimensions[key] || [];
        if (key === 'nicotine') return values.some((value) => value >= selected.min && value <= selected.max);
        return selected.some((value) => values.some((item) => item.value === value));
      });
    }

    filteredProducts(excludedKey, provisional) {
      return this.products.filter((product) => this.matches(product, excludedKey, provisional));
    }

    availableValues(key) {
      if (key === 'entry') return [
        this.item('type', this.labels.pathType),
        this.item('brand', this.labels.pathBrand),
      ];
      return this.unique(this.filteredProducts(key).flatMap((product) => product.dimensions[key] || []).filter((value) => typeof value !== 'number'));
    }

    availableNumbers(key) {
      return [...new Set(this.filteredProducts(key).flatMap((product) => product.dimensions[key] || []).filter((value) => typeof value === 'number'))].sort((a, b) => a - b);
    }

    nextStep() {
      const flow = this.getFlow();
      for (const step of flow) {
        if (Object.prototype.hasOwnProperty.call(this.state, step.key)) continue;
        const count = step.flavorFilter
          ? Math.max(this.availableValues('flavor').length, this.availableValues('taste').length)
          : step.range
            ? this.availableNumbers(step.key).length
            : this.availableValues(step.key).length;
        if (count > 0) return step;
      }
      return null;
    }

    render() {
      this.renderSummary();
      const products = this.filteredProducts();
      if (this.history.length && products.length === 1 && this.dataset.autoRedirect === 'true' && !this.config.designMode) {
        window.location.assign(this.productUrl(products[0]));
        return;
      }
      const next = this.nextStep();
      this.updateJourney(next, products.length);
      if (next) this.renderStep(next);
      else this.renderResults(products);
      this.backButton.hidden = this.history.length === 0;
      this.resetButton.hidden = this.history.length === 0;
    }

    updateJourney(next, count) {
      const flow = this.getFlow();
      const total = Math.max(flow.length, 1);
      const current = next ? Math.min(this.history.length + 1, total) : total;
      const routeIsKnown = Boolean(this.state.entry?.[0])
        && (this.state.entry[0] === 'brand' || Boolean(this.state.category?.[0]));
      const progressTotal = routeIsKnown ? total : 5;
      const progress = next ? Math.max(8, (this.history.length / progressTotal) * 100) : 100;
      this.progressFill.style.width = `${progress}%`;
      this.progressText.textContent = routeIsKnown || !next
        ? this.labels.stepOf.replace('[current]', current).replace('[total]', total)
        : this.labels.step.replace('[current]', this.history.length + 1);
      this.liveCount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR').format(count);
    }

    renderSummary() {
      this.summary.replaceChildren();
      if (!this.history.length) {
        const empty = document.createElement('li');
        empty.className = 'product-finder__summary-empty';
        empty.textContent = this.labels.startHere;
        this.summary.append(empty);
        return;
      }
      this.history.forEach((key, index) => {
        const selected = this.state[key];
        const labels = key === 'nicotine'
          ? [`${selected.min}–${selected.max} mg/ml`]
          : selected.map((value) => this.findLabel(key, value));
        const item = document.createElement('li');
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = `${this.labels[key]} : ${labels.length ? labels.join(', ') : this.labels.allValues}`;
        button.addEventListener('click', () => {
          this.history.slice(index).forEach((historyKey) => delete this.state[historyKey]);
          this.history = this.history.slice(0, index);
          this.render();
        });
        item.append(button);
        this.summary.append(item);
      });
    }

    findLabel(key, value) {
      const found = this.products.flatMap((product) => product.dimensions[key] || []).find((item) => item.value === value);
      return found?.label || this.labelize(value);
    }

    renderStep(step) {
      this.currentStep = step;
      this.pending = new Set();
      this.step.dataset.stepKey = step.key;
      this.results.hidden = true;
      this.step.hidden = false;
      this.choices.hidden = Boolean(step.range);
      this.rangePanel.hidden = !step.range;
      this.flavorModeControl.hidden = !step.flavorFilter;
      this.flavorModeControl.querySelectorAll('[data-flavor-mode-value]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.flavorModeValue === this.flavorMode));
      });
      this.choiceSearchWrap.hidden = true;
      this.choiceSearch.value = '';
      this.actions.hidden = !(step.multi || step.range || step.optional);
      this.querySelector('[data-step-count]').textContent = this.labels.step.replace('[current]', this.history.length + 1);
      this.querySelector('[data-step-title]').textContent = this.labels[step.key];
      this.querySelector('[data-step-help]').textContent = this.labels[`${step.key}Help`];
      const allButton = this.querySelector('[data-step-all]');
      const continueButton = this.querySelector('[data-step-continue]');
      allButton.textContent = step.key === 'brand' ? this.labels.allBrands : this.labels.allValues;
      allButton.hidden = !(step.multi || step.optional);
      continueButton.hidden = !(step.multi || step.range);
      continueButton.disabled = false;
      continueButton.textContent = this.labels.continue;
      this.choices.replaceChildren();
      if (step.range) {
        const numbers = this.availableNumbers(step.key);
        this.rangeMin.value = Math.max(0, Math.floor(Math.min(...numbers)));
        this.rangeMax.value = Math.min(20, Math.ceil(Math.max(...numbers)));
        this.syncRange();
      } else {
        const values = this.availableValues(step.key);
        this.choiceSearchWrap.hidden = values.length <= 12;
        values.forEach((item) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'product-finder__choice';
          button.dataset.value = item.value;
          button.dataset.choiceKey = step.key;
          button.setAttribute('aria-pressed', 'false');
          const icon = document.createElement('span');
          icon.className = 'product-finder__choice-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = this.choiceIcon(step.key, item.value, item.label);
          const copy = document.createElement('span');
          copy.className = 'product-finder__choice-copy';
          const label = document.createElement('span');
          label.className = 'product-finder__choice-label';
          label.textContent = item.label;
          const descriptionText = this.choiceDescription(step.key, item.value);
          if (descriptionText) {
            const description = document.createElement('span');
            description.className = 'product-finder__choice-description';
            description.textContent = descriptionText;
            copy.append(label, description);
          } else copy.append(label);
          const count = document.createElement('small');
          const matches = this.filteredProducts(step.key, { [step.key]: [item.value] }).length;
          count.textContent = this.matchLabel(matches);
          copy.append(count);
          const arrow = document.createElement('span');
          arrow.className = 'product-finder__choice-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = step.multi ? '✓' : '→';
          button.append(icon, copy, arrow);
          button.addEventListener('click', () => {
            if (step.multi) {
              if (this.pending.has(item.value)) this.pending.delete(item.value);
              else this.pending.add(item.value);
              button.setAttribute('aria-pressed', String(this.pending.has(item.value)));
              this.updateContinueCount();
            } else {
              this.state[step.key] = [item.value];
              this.history.push(step.key);
              this.render();
            }
          });
          this.choices.append(button);
        });
        if (step.multi) this.updateContinueCount();
      }
    }

    choiceIcon(key, value, label) {
      const icons = {
        'entry:type': '01', 'entry:brand': 'A–Z',
        'category:e-liquides': 'EL', 'category:puffs': 'PF',
        'category:diy': 'DIY', 'category:materiel': 'MT',
      };
      return icons[`${key}:${value}`] || String(label || value).trim().slice(0, 2).toUpperCase();
    }

    choiceDescription(key, value) {
      const descriptions = {
        'entry:type': this.labels.pathTypeHelp,
        'entry:brand': this.labels.pathBrandHelp,
        'category:e-liquides': this.labels.categoryEliquidsHelp,
        'category:puffs': this.labels.categoryPuffsHelp,
        'category:diy': this.labels.categoryDiyHelp,
        'category:materiel': this.labels.categoryHardwareHelp,
      };
      return descriptions[`${key}:${value}`] || '';
    }

    setFlavorMode(mode) {
      if (!['flavor', 'taste'].includes(mode) || mode === this.flavorMode) return;
      this.flavorMode = mode;
      this.renderStep({ ...this.currentStep, key: mode, flavorFilter: true });
    }

    filterChoices() {
      const query = this.normalize(this.choiceSearch.value);
      this.choices.querySelectorAll('[data-value]').forEach((button) => {
        button.hidden = Boolean(query) && !this.normalize(button.textContent).includes(query);
      });
    }

    syncRange(changed) {
      let min = Number(this.rangeMin.value);
      let max = Number(this.rangeMax.value);
      if (min > max) {
        if (changed === 'min') max = min;
        else min = max;
      }
      this.rangeMin.value = min;
      this.rangeMax.value = max;
      this.querySelector('[data-range-min-output]').textContent = min;
      this.querySelector('[data-range-max-output]').textContent = max;
      this.updateContinueCount();
    }

    updateContinueCount() {
      const button = this.querySelector('[data-step-continue]');
      let provisional;
      if (this.currentStep.range) provisional = { [this.currentStep.key]: { min: Number(this.rangeMin.value), max: Number(this.rangeMax.value) } };
      else provisional = { [this.currentStep.key]: [...this.pending] };
      const count = this.filteredProducts(this.currentStep.key, provisional).length;
      button.textContent = `${this.labels.continue} · ${this.matchLabel(count)}`;
      button.disabled = count === 0;
    }

    matchLabel(count) {
      return (count === 1 ? this.labels.oneMatch : this.labels.matches).replace('[count]', count);
    }

    commitStep() {
      const key = this.currentStep.key;
      if (this.currentStep.range) this.state[key] = { min: Number(this.rangeMin.value), max: Number(this.rangeMax.value) };
      else this.state[key] = [...this.pending];
      this.history.push(key);
      this.render();
    }

    skipStep() {
      this.state[this.currentStep.key] = [];
      this.history.push(this.currentStep.key);
      this.render();
    }

    goBack() {
      const key = this.history.pop();
      if (key) delete this.state[key];
      this.render();
    }

    reset() {
      this.state = {};
      this.history = [];
      this.flavorMode = 'flavor';
      this.render();
    }

    renderResults(products) {
      this.step.hidden = true;
      this.results.hidden = false;
      this.querySelector('[data-results-title]').textContent = this.labels.resultsTitle;
      this.querySelector('[data-results-count]').textContent = this.matchLabel(products.length);
      const grid = this.querySelector('[data-results-grid]');
      const empty = this.querySelector('[data-results-empty]');
      grid.replaceChildren();
      empty.hidden = products.length > 0;
      grid.hidden = products.length === 0;
      products.forEach((product) => grid.append(this.productCard(product)));
      this.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    productUrl(product) {
      return `${this.config.rootUrl}products/${encodeURIComponent(product.handle)}`;
    }

    productCard(product) {
      const article = document.createElement('article');
      article.className = 'product-card product-finder__card';
      const media = document.createElement('a');
      media.className = 'product-card__media';
      media.href = this.productUrl(product);
      media.setAttribute('aria-label', product.title);
      const imageData = product.images?.[0];
      if (imageData?.src) {
        const image = document.createElement('img');
        image.src = imageData.src;
        image.alt = imageData.alt || product.title;
        image.loading = 'lazy';
        image.width = imageData.width || 600;
        image.height = imageData.height || 600;
        media.append(image);
      }
      const available = (product.variants || []).filter((variant) => variant.available);
      if (!available.length) {
        const badge = document.createElement('span');
        badge.className = 'product-card__badge';
        badge.textContent = this.labels.soldOut;
        media.append(badge);
      }
      const body = document.createElement('div');
      body.className = 'product-card__body';
      if (this.dataset.showVendor === 'true' && product.vendor) {
        const vendor = document.createElement('p');
        vendor.className = 'eyebrow';
        vendor.textContent = product.vendor;
        body.append(vendor);
      }
      const title = document.createElement('h3');
      const titleLink = document.createElement('a');
      titleLink.href = this.productUrl(product);
      titleLink.textContent = product.title;
      title.append(titleLink);
      body.append(title);
      const productMeta = this.flavorMap.get(product.handle) || {};
      const hasPromotion = product.variants?.some((variant) => Number(variant.compare_at_price) > Number(variant.price));
      if (productMeta.prixDeliquide || hasPromotion) {
        const priceLabel = document.createElement('span');
        priceLabel.className = `price-label price-label--${productMeta.prixDeliquide ? 'deliquide' : 'promotion'}`;
        priceLabel.textContent = productMeta.prixDeliquide ? this.labels.prixDeliquide : this.labels.promotion;
        body.append(priceLabel);
      }
      const price = document.createElement('p');
      price.className = 'product-card__price';
      const prices = available.map((variant) => Number(variant.price)).filter(Number.isFinite);
      const lowest = prices.length ? Math.min(...prices) : Number(product.variants?.[0]?.price || 0);
      const money = this.formatMoney(lowest);
      price.textContent = new Set(prices).size > 1 ? this.labels.fromPrice.replace('[price]', money) : money;
      body.append(price);
      if (this.dataset.showQuickAdd === 'true') {
        const action = document.createElement('div');
        action.className = 'product-card__action';
        if (product.variants?.length === 1 && available.length === 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = this.labels.quickAdd;
          button.addEventListener('click', () => this.addToCart(button, available[0].id));
          action.append(button);
        } else if (available.length) {
          const link = document.createElement('a');
          link.className = 'button-secondary';
          link.href = this.productUrl(product);
          link.textContent = this.labels.chooseOptions;
          action.append(link);
        } else {
          const button = document.createElement('button');
          button.type = 'button';
          button.disabled = true;
          button.textContent = this.labels.soldOut;
          action.append(button);
        }
        body.append(action);
      }
      article.append(media, body);
      return article;
    }

    async addToCart(button, variantId) {
      const previous = button.textContent;
      button.disabled = true;
      try {
        const response = await fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        if (!response.ok) throw new Error();
        const cartResponse = await fetch(this.config.cartUrl, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: this.id || 'product-finder', data: { source: 'product-finder', itemCount: cart.item_count } },
        }));
        button.textContent = this.labels.added;
        setTimeout(() => {
          button.textContent = previous;
          button.disabled = false;
        }, 1600);
      } catch (error) {
        button.textContent = this.labels.addError;
        setTimeout(() => {
          button.textContent = previous;
          button.disabled = false;
        }, 1800);
      }
    }

    formatMoney(value) {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: this.config.currency || 'EUR',
      }).format(Number(value || 0));
    }
  }

  if (!customElements.get('product-finder')) customElements.define('product-finder', ProductFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) {
          this.loadRecommendations();
          return;
        }

        this.observer = new IntersectionObserver((entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations();
        }, { rootMargin: '300px 0px' });

        this.observer.observe(this);
      }

      async loadRecommendations() {
        const [complementary, related] = await Promise.all([
          this.fetchRecommendations(this.dataset.complementaryUrl),
          this.fetchRecommendations(this.dataset.relatedUrl)
        ]);
        const source = complementary?.surface || related?.surface;

        if (!source) {
          this.remove();
          return;
        }

        const grid = source.querySelector('.product-upsell__grid');
        const limit = Number.parseInt(this.dataset.limit, 10) || 4;
        const selected = [];
        const seen = new Set();
        const addItem = (item) => {
          if (!item || selected.length >= limit) return;
          const link = item.querySelector('.product-card h3 a')?.href;
          const key = link ? new URL(link, window.location.origin).pathname : '';
          if (!key || seen.has(key)) return;
          seen.add(key);
          selected.push(item.cloneNode(true));
        };

        addItem(complementary?.items[0]);
        related?.items.forEach(addItem);
        complementary?.items.slice(1).forEach(addItem);

        if (!grid || selected.length === 0) {
          this.remove();
          return;
        }

        grid.replaceChildren(...selected);
        this.innerHTML = source.outerHTML;
      }

      async fetchRecommendations(url) {
        if (!url) return null;

        try {
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) return null;

          const html = document.createElement('div');
          html.innerHTML = await response.text();
          const surface = html.querySelector('.product-upsell__surface');
          if (!surface) return null;

          return {
            surface,
            items: [...surface.querySelectorAll('.product-upsell__item')]
          };
        } catch (error) {
          return null;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shipping-estimate')) {
    customElements.define('shipping-estimate', class ShippingEstimate extends HTMLElement {
      connectedCallback() {
        const details = this.closest('.product-page__details');
        this.variant = details?.querySelector('select[name="id"]');
        this.quantity = details?.querySelector('input[name="quantity"]');
        this.relayMessage = this.querySelector('[data-relay-message]');
        this.relayProgress = this.querySelector('[data-relay-progress]');
        this.relayTrack = this.querySelector('.relay-progress__track');
        this.displayedPrice = details?.querySelector('[data-product-price]');
        this.cartSubtotal = Number(this.dataset.cartSubtotal || 0);
        this.variant?.addEventListener('change', () => this.update());
        this.quantity?.addEventListener('input', () => this.update());
        document.addEventListener('cart:update', (event) => {
          const cart = event.detail?.resource;
          if (cart) {
            this.cartSubtotal = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
            this.update();
          } else {
            this.refreshCart();
          }
        });
        this.update();
        this.refreshCart();
      }

      async refreshCart() {
        try {
          const response = await fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          this.cartSubtotal = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
          this.update();
        } catch (error) {
          // The Liquid subtotal remains a safe fallback when the cart endpoint is unavailable.
        }
      }

      update() {
        const selected = this.variant?.selectedOptions?.[0];
        const unitPrice = Number(selected?.dataset.price ?? this.dataset.initialPrice ?? 0);
        if (selected?.dataset.priceDisplay && this.displayedPrice) this.displayedPrice.textContent = selected.dataset.priceDisplay;
        const quantity = Math.max(1, Number(this.quantity?.value || 1));
        const subtotal = this.cartSubtotal + (unitPrice * quantity);
        const remaining = Math.max(0, 2000 - subtotal);
        if (this.relayMessage) this.relayMessage.textContent = remaining > 0 ? `Plus que ${new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(remaining / 100)}` : 'Livraison offerte';
        if (this.relayProgress) this.relayProgress.style.width = `${Math.min(100, subtotal / 20)}%`;
        if (this.relayTrack) this.relayTrack.setAttribute('aria-valuenow', String(Math.min(20, subtotal / 100)));
      }
    });
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.product-gallery__track');
        this.slides = Array.from(this.querySelectorAll('[data-product-slide]'));
        this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
        this.current = this.querySelector('[data-gallery-current]');
        this.previous = this.querySelector('[data-gallery-previous]');
        this.next = this.querySelector('[data-gallery-next]');
        this.index = 0;
        this.frame = null;
        if (this.slides.length < 2) return;
        this.previous?.addEventListener('click', () => this.goTo(this.index - 1));
        this.next?.addEventListener('click', () => this.goTo(this.index + 1));
        this.thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => this.goTo(Number(thumbnail.dataset.galleryIndex))));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateFromScroll());
        }, { passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.index - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.index + 1);
          }
        });
        this.sync();
      }

      goTo(index) {
        const target = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: this.track.clientWidth * target, behavior: 'smooth' });
        this.index = target;
        this.sync();
      }

      updateFromScroll() {
        const nextIndex = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (nextIndex !== this.index && this.slides[nextIndex]) {
          this.index = nextIndex;
          this.sync();
        }
      }

      sync() {
        this.slides.forEach((slide, index) => slide.setAttribute('aria-hidden', index === this.index ? 'false' : 'true'));
        this.thumbnails.forEach((thumbnail, index) => thumbnail.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
        if (this.current) this.current.textContent = String(this.index + 1);
        this.thumbnails[this.index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shopify-default-slideshow').forEach((slideshow) => {
    const viewport = slideshow.querySelector('[data-slideshow-viewport]');
    const slides = Array.from(slideshow.querySelectorAll('[data-slideshow-slide]'));
    const dots = Array.from(slideshow.querySelectorAll('[data-slideshow-dot]'));
    if (!viewport || slides.length < 2) return;
    const goTo = (index) => viewport.scrollTo({ left: viewport.clientWidth * ((index + slides.length) % slides.length), behavior: 'smooth' });
    slideshow.querySelector('[data-slideshow-previous]')?.addEventListener('click', () => goTo(Math.round(viewport.scrollLeft / viewport.clientWidth) - 1));
    slideshow.querySelector('[data-slideshow-next]')?.addEventListener('click', () => goTo(Math.round(viewport.scrollLeft / viewport.clientWidth) + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.slideshowDot))));
    viewport.addEventListener('scroll', () => {
      const active = Math.round(viewport.scrollLeft / viewport.clientWidth);
      dots.forEach((dot, index) => dot.setAttribute('aria-current', index === active ? 'true' : 'false'));
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
